export const QuestionnaireList = [
    {
        prop: "id",
        label: "问卷ID",
        width: "150",
        format: "",
        order: true,
        isShow: false
    },
    {
        prop: "title",
        label: "问卷标题",
        width: "510",
        format: "",
        order: true,
        isShow: true
    },
    {
        prop: "status",
        label: "状态",
        width: "180",
        format: "dropdown",
        order: true,
        isShow: true
    },
    {
        prop: "startDate",
        label: "开始时间",
        width: "100",
        format: "date",
        order: true,
        isShow: true
    },
    {
        prop: "endDate",
        label: "结束时间",
        width: "100",
        format: "date",
        order: true,
        isShow: true
    },
    {
        prop: "creationTime",
        label: "创建时间",
        width: "200",
        format: "datetime",
        order: true,
        isShow: true
    },
    {
        prop: "creatorId",
        label: "创建人",
        width: "150",
        format: "",
        order: false,
        isShow: false
    },
    {
        prop: "lastModificationTime",
        label: "最后修改时间",
        width: "200",
        format: "datetime",
        order: true,
        isShow: true
    },
]



